import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueCompositionAPI from '@vue/composition-api'
// Import Bootstrap an BootstrapVue CSS files (order is important)
import '@vueform/multiselect/themes/default.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import PrettyCheckbox from 'pretty-checkbox-vue'
import Vue from 'vue'
import ToggleButton from 'vue-js-toggle-button'
import VueFragment from 'vue-fragment'
import './app.scss'
import App from './App.vue'
import router from './router'
import store from './store'
import 'animate.css'
import Eagle, {Presenter} from 'eagle.js'

import 'eagle.js/dist/themes/agrume/agrume.css'

Eagle.use(Presenter, {
  presenterModeKey: 'a' // default is p
})

Vue.use(Eagle)
Vue.use(VueFragment)
Vue.use(ToggleButton)
library.add(faUserSecret)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(PrettyCheckbox)
Vue.use(VueCompositionAPI)

Vue.config.productionTip = false


new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
